import $ from 'jquery';
import identifications from './components/identification';

import { init } from './shared/login';

import { render } from '~/theseus';
import Navbar from '~/theseus/components/Navbar';

function load_data() {
  identifications($('#settings'));
}

init()
  .then(load_data);
